export enum CleverTapEventsCatalogTaxes {
  webCatalogTaxesCreateTax = 'Web_Catalog_Taxes_Create_Tax',
  webCatalogTaxesEditTax = 'Web_Catalog_Tax_MM_Edit_Tax',
  webCatalogTaxesDeleteTax = 'Web_Catalog_Tax_MM_Delete_Tax',
  webCatalogTaxesCreateTaxSaveClicked = 'Web_Catalog_Tax_Create_Tax_Save_Clicked',
  webCatalogTaxesEditTaxSaveClicked = 'Web_Catalog_Tax_Edit_Tax_Save_Clicked',
  webCatalogTaxesEditTaxDeleteClicked = 'Web_Catalog_Tax_Edit_Tax_Delete_Clicked',
  webCatalogTaxesSearch = 'Web_Catalog_Tax_Search'
}
